export const MAX_LIMIT = 10;

export const MIME_TYPES = [
  "image/jpg", //jpg
  "image/jpeg", // jpeg
  "image/png", // png
  "image/heic", // heic
  "image/bmp", // bmp
  "image/gif", // gif
  "image/tiff", // tiff
  "video/mp4", // mp4
  "video/quicktime", // mov
  "video/x-msvideo", // avi
  "video/x-ms-wmv", // wmv
  "video/mpeg", // mpeg
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // xlsx
  "application/vnd.ms-excel", // xls
  "application/vnd.oasis.opendocument.spreadsheet", // ods
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // docx
  "application/msword", // doc
  "application/vnd.oasis.opendocument.text", // odt
  "application/vnd.openxmlformats-officedocument.presentationml.presentation", // pptx
  "application/vnd.ms-powerpoint", // ppt
  "application/vnd.oasis.opendocument.presentation", // odp
  "application/pdf", // pdf
  "application/rtf", // rtf
  "text/plain", // txt
];
